export default __webpack_public_path__ + "static/media/bookworm-orange.72f18e0a.svg";